import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { auth, db, getCollectionName } from './firebase';
import { onAuthStateChanged, signOut as sairDoSistema, sendPasswordResetEmail } from './auth-compat';
import { situacaoSenha } from './utils/senhaPolitica';
import { collection, query, where, onSnapshot } from './firestore-compat';
import { supabase } from './supabase';

import { loadSpeechConfig } from './utils/speechUtils';
import { usePresenceHeartbeat } from './hooks/usePresenceHeartbeat';
import { useManutencao } from './hooks/useManutencao';
import Login from './Login';
import ChangePassword from './ChangePassword';
import NovaSenha from './NovaSenha';
import ValidarCertificado from './ValidarCertificado';
import Home from './Home'; // Atualizado
import MainApp from './MainApp';
import CronogramaProjeto from './CronogramaProjeto';
import ProjetoDirecao from './ProjetoDirecao';
import ProjetoObrasDirecao from './ProjetoObrasDirecao';
import ProjetoHomecare from './ProjetoHomecare';
import MeuProjeto from './MeuProjeto';
import Settings from './Settings';
import Analysis from './Analysis';
import AgendaQualidade from './AgendaQualidade';
import AgendaHomecare from './AgendaHomecare';
import TarefasHomecare from './TarefasHomecare';
import TarefasQualidade from './TarefasQualidade';
import IndicadorAgenda from './IndicadorAgenda';
import AgendaDirecao from './AgendaDirecao';
import AgendaCaptacao from './AgendaCaptacao';
import Convites from './Convites';
import MinhaAgenda from './MinhaAgenda';
import MinhasTarefas from './MinhasTarefas';
import Notificacoes from './Notificacoes';
import AuditPermissions from './AuditPermissions';
import AdminEventos from './AdminEventos';
import MainLayout from './components/MainLayout';
import TutoriaisPublico from './TutoriaisPublico';
import AdminTutoriais from './AdminTutoriais';
import DocumentManager from './DocumentManager';
import HtmlViewer from './HtmlViewer';
import DashboardPlanilha from './DashboardPlanilha';
import PainelTelefonia from './telefonia/PainelTelefonia';
import TesteJarvis from './jarvis/TesteJarvis';
import Email from './email/Email';
import HistoricoAcessos from './HistoricoAcessos';
import DashboardOpenzap from './DashboardOpenzap';
import EscalasTecnicos from './EscalasTecnicos';
import EscalasEnfermeiros from './EscalasEnfermeiros';
import FormularioPassagem from './FormularioPassagem';
import GestaoPassagens from './GestaoPassagens';
import PortalCooperativa from './PortalCooperativa';
import PortalRH from './PortalRH';
import PortalTI from './PortalTI';
import PatientManagement from './PatientManagement';
import DashboardIndicadores from './DashboardIndicadores';
import MapaPacientes from './MapaPacientes';
import OcorrenciaSetores from './OcorrenciaSetores';
import OcorrenciaDetalhe from './OcorrenciaDetalhe';
import DashboardHospitalizacao from './DashboardHospitalizacao';
import DashboardImplantacao from './DashboardImplantacao';
import DashboardFeridas from './DashboardFeridas';
import GestaoOcorrencias from './GestaoOcorrencias';
import WizardOcorrencia from './WizardOcorrencia';
import Captacao from './Captacao';
import DashboardHub from './DashboardHub';
import DashboardDispositivos from './DashboardDispositivos';
import UploadHub from './UploadHub';
import DashboardVisitas from './DashboardVisitas';
import PainelImplantados from './PainelImplantados';
import Intranet from './Intranet';
import DashboardProntuario from './DashboardProntuario';
import GestaoOrcamentos from './GestaoOrcamentos';
import PainelProrrogacoes from './prorrogacoes/PainelProrrogacoes';
import GestaoVisitasProdutividade from './GestaoVisitasProdutividade';
import GestaoPreviaRecargas from './GestaoPreviaRecargas';
import GestaoSolicitacaoRemocao from './GestaoSolicitacaoRemocao';
import GestaoSolicitacaoTroca from './GestaoSolicitacaoTroca';
import GestaoSolicitacaoExames from './GestaoSolicitacaoExames';
import GestaoMonitoramentoClinico from './GestaoMonitoramentoClinico';
import EnvioCarefy from './carefy/EnvioCarefy';
import GestaoFeridas from './GestaoFeridas';
import GestaoOuvidorias from './GestaoOuvidorias';
import GestaoRemocoes from './GestaoRemocoes';
import RegrasContrato from './RegrasContrato';
import AbrirChamado from './AbrirChamado';
import MeusChamados from './MeusChamados';
import PainelChamados from './PainelChamados';
import ChamadoDetalhes from './ChamadoDetalhes';
import LiberacaoKits from './LiberacaoKits';
import PainelInfeccao from './PainelInfeccao';
import Huddle from './Huddle';
import OuvidoriaMonitoramento from './OuvidoriaMonitoramento';
import InepEnsino from './InepEnsino';
import GestaoControladoria from './GestaoControladoria';
import GestaoLogistica from './GestaoLogistica';

export const AuthContext = React.createContext();

// Bloqueio e validade da senha (Configurações → Usuários). Chamado quando o registro do
// usuário carrega e a cada 30 s: quem foi bloqueado sai; quem está com a senha vencida
// ou marcada "Trocar agora" sai e vai para a troca por código (o código já vai por e-mail).
let acaoDeContaEmAndamento = false;
async function verificarConta(userData, email) {
  if (!userData || !email || acaoDeContaEmAndamento) return;
  if (window.location.pathname.startsWith('/nova-senha')) return; // já está trocando
  if (userData.bloqueado) {
    acaoDeContaEmAndamento = true;
    try { await sairDoSistema(auth); } catch (_) { /* segue para o login */ }
    window.location.href = '/login?bloqueado=1';
    return;
  }
  if (situacaoSenha(userData).vencida) {
    acaoDeContaEmAndamento = true;
    const e = email.toLowerCase();
    let enviado = '1';
    try { await sendPasswordResetEmail(auth, e); } catch (_) { enviado = '0'; }
    try { await sairDoSistema(auth); } catch (_) { /* segue */ }
    window.location.href = `/nova-senha?email=${encodeURIComponent(e)}&modo=expirada&enviado=${enviado}`;
  }
}

const PrivateRoute = ({ children }) => {
  const { user, mustChangePassword } = React.useContext(AuthContext);
  const location = useLocation();
  if (!user) return <Navigate to="/login" />;
  if (mustChangePassword) return <Navigate to="/change-password" />;
  // Aluno só INEP: qualquer tela fora do portal do INEP volta para ele
  if (user.soInep && !location.pathname.startsWith('/inep')) return <Navigate to="/inep" replace />;
  return (
    <MainLayout>
      {children}
    </MainLayout>
  );
};

function App() {
  const [user, setUser] = useState(null);
  // Carrega configurações de voz do Firestore (uma vez)
  useEffect(() => { loadSpeechConfig(); }, []); // eslint-disable-line
  const [loading, setLoading] = useState(true);
  const [mustChangePassword, setMustChangePassword] = useState(false);
  // login sem cadastro no Quality (usuário excluído antes do bloqueio, conta antiga do Firebase…): não entra
  const [semCadastro, setSemCadastro] = useState(false);

  usePresenceHeartbeat(user);
  const manutencao = useManutencao();

  useEffect(() => {
    let userDocUnsub = null;

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);

      // Cancela listener anterior do documento do usuário
      if (userDocUnsub) { userDocUnsub(); userDocUnsub = null; }

      if (currentUser) {
        const q = query(
          collection(db, getCollectionName('users')),
          where('email', '==', currentUser.email)
        );

        // onSnapshot: detecta forcePasswordChange no documento do usuário
        userDocUnsub = onSnapshot(q, (snap) => {
          if (snap.empty) { setMustChangePassword(false); setSemCadastro(currentUser.email !== 'alexandrebareaoliveira@gmail.com'); setLoading(false); return; }
          setSemCadastro(false);
          const userData = snap.docs[0].data();
          setMustChangePassword(!!userData.forcePasswordChange);
          setLoading(false);
          verificarConta(userData, currentUser.email);
        }, () => { setMustChangePassword(false); setLoading(false); });

      } else {
        setMustChangePassword(false);
        setLoading(false);
      }
    });

    return () => { unsubscribe(); if (userDocUnsub) userDocUnsub(); };
  }, []);

  // Bloqueio / "Trocar agora" / senha vencida: confere o próprio registro a cada 30 s
  // (o admin muda em Configurações → Usuários e a pessoa sai em até 30 s).
  useEffect(() => {
    if (!user?.email) return undefined;
    const confere = async () => {
      try {
        const { data: row } = await supabase.from('users').select('data')
          .eq('data->>email', user.email.toLowerCase()).limit(1).maybeSingle();
        if (row?.data) verificarConta(row.data, user.email);
        else if (row === null && user.email !== 'alexandrebareaoliveira@gmail.com') setSemCadastro(true);
      } catch (_) { /* falha de rede: tenta no próximo ciclo */ }
    };
    const t = setInterval(confere, 30000);
    return () => clearInterval(t);
  }, [user]);

  // Single-session: polling verifica se o token local ainda é o ativo no banco.
  // Se outro dispositivo fez login, o token no banco muda e esta sessão é encerrada.
  useEffect(() => {
    if (!user) return;
    // SuperAdmin isento para fins de suporte
    if (user.email === 'alexandrebareaoliveira@gmail.com') return;

    // Grace period: não verifica nos primeiros 30s após montar,
    // dando tempo para o token do login propagar no banco.
    const GRACE_MS = 30000;
    const mountedAt = Date.now();

    const checkSession = async () => {
      // Sem token local = DB write falhou no login, não enforce single-session
      const localToken = localStorage.getItem('qh_session_token');
      if (!localToken) return;

      // Ainda no grace period
      if (Date.now() - mountedAt < GRACE_MS) return;

      try {
        const { data: row } = await supabase
          .from('users')
          .select('data')
          .eq('data->>email', user.email.toLowerCase())
          .limit(1)
          .maybeSingle();

        const dbToken = row?.data?.sessionToken;
        const sessionAt = row?.data?.sessionAt;

        // Sem token no banco = single-session nunca foi ativado, ignora
        if (!dbToken || !sessionAt) return;

        // Só expulsa se o token foi gravado nos últimos 5 minutos
        // (token antigo = sessão já encerrada, não é login ativo)
        const ageMs = Date.now() - new Date(sessionAt).getTime();
        if (ageMs > 5 * 60 * 1000) return;

        if (dbToken !== localToken) {
          console.warn('[single-session] Sessão expirada — login detectado em outro dispositivo');
          localStorage.removeItem('qh_session_token');
          const { signOut: doSignOut } = await import('./auth-compat');
          await doSignOut(auth);
        }
      } catch (_) { /* falha de rede, tenta de novo no próximo ciclo */ }
    };

    const firstCheck = setTimeout(checkSession, GRACE_MS);
    const interval = setInterval(checkSession, 30000);
    return () => { clearTimeout(firstCheck); clearInterval(interval); };
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return <div>Carregando...</div>;
  }

  // Modo manutenção (Fase 7/8 da migração): bloqueia todo mundo, exceto o
  // superadmin, enquanto a troca de servidor estiver em andamento. Ligado/
  // desligado em Configurações > Sistema, ou direto na tabela sistema_manutencao.
  const isSuperAdmin = user?.email === 'alexandrebareaoliveira@gmail.com';
  if (user && semCadastro && !isSuperAdmin) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#f4f7f6', fontFamily: 'Segoe UI, Arial, sans-serif' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: '28px 30px', maxWidth: 440, textAlign: 'center', boxShadow: '0 12px 32px -14px rgba(0,0,0,.3)' }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔒</div>
          <div style={{ fontSize: '1.2rem', fontWeight: 800, color: '#1e293b', marginBottom: 8 }}>Acesso não liberado</div>
          <p style={{ color: '#475569', fontSize: '.95rem', lineHeight: 1.5, margin: '0 0 18px' }}>
            O e-mail <strong>{user.email}</strong> não tem cadastro ativo no Quality. Fale com o administrador do sistema para liberar o seu acesso.
          </p>
          <button onClick={async () => { try { const { signOut } = await import('./auth-compat'); await signOut(auth); } catch (_) { /* segue */ } window.location.href = '/login'; }}
            style={{ background: '#00897b', color: '#fff', border: 0, borderRadius: 10, padding: '10px 22px', fontWeight: 700, cursor: 'pointer' }}>Sair</button>
        </div>
      </div>
    );
  }
  if (manutencao?.ativo && !isSuperAdmin) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', textAlign: 'center',
        background: '#1a1a2e', color: '#fff', padding: 24, fontFamily: 'inherit',
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🛠️</div>
        <h1 style={{ margin: '0 0 8px', fontSize: 24 }}>Sistema em manutenção</h1>
        <p style={{ maxWidth: 480, opacity: 0.85 }}>
          {manutencao.mensagem || 'Estamos fazendo uma atualização programada. Voltamos em breve.'}
        </p>
      </div>
    );
  }

  // Helper para rota privada removido para fora do componente App para evitar unmounts

  return (
    <AuthContext.Provider value={{ user, mustChangePassword }}>
      <BrowserRouter>
        <Routes>
        {/* --- ROTAS PÚBLICAS --- */}
        <Route path="/login" element={user ? <Navigate to="/home" /> : <Login />} />
        <Route path="/tutoriais" element={<TutoriaisPublico />} />
        {/* Recuperação de senha por e-mail — pública (a pessoa fica logada só depois de validar o código) */}
        <Route path="/nova-senha" element={<NovaSenha />} />
        {/* Validação pública do certificado do INEP (o QR code abre aqui) */}
        <Route path="/validar/:cod" element={<ValidarCertificado />} />

        {/* --- ROTA DE TROCA DE SENHA (Semi-Privada) --- */}
        <Route path="/change-password" element={user ? <ChangePassword /> : <Navigate to="/login" />} />

        {/* --- ROTAS PRIVADAS (PROTEGIDAS pelo Layout) --- */}
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/app" element={<PrivateRoute><MainApp /></PrivateRoute>} />
        <Route path="/cronograma-iw" element={<PrivateRoute><CronogramaProjeto /></PrivateRoute>} />
        <Route path="/projeto-direcao" element={<PrivateRoute><ProjetoDirecao /></PrivateRoute>} />
        <Route path="/obras-direcao" element={<PrivateRoute><ProjetoObrasDirecao /></PrivateRoute>} />
        <Route path="/projeto-homecare" element={<PrivateRoute><ProjetoHomecare /></PrivateRoute>} />
        <Route path="/meu-projeto" element={<PrivateRoute><MeuProjeto /></PrivateRoute>} />
        <Route path="/audit" element={<PrivateRoute>{isSuperAdmin ? <AuditPermissions /> : <Navigate to="/home" replace />}</PrivateRoute>} />
        <Route path="/admin-eventos" element={<PrivateRoute>{isSuperAdmin ? <AdminEventos /> : <Navigate to="/home" replace />}</PrivateRoute>} />
        <Route path="/historico-acessos" element={<PrivateRoute>{isSuperAdmin ? <HistoricoAcessos /> : <Navigate to="/home" replace />}</PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/analysis" element={<PrivateRoute><Analysis /></PrivateRoute>} />

        <Route path="/agenda-qualidade" element={<PrivateRoute><AgendaQualidade /></PrivateRoute>} />
        <Route path="/agenda-homecare" element={<PrivateRoute><AgendaHomecare /></PrivateRoute>} />
        <Route path="/tarefas-homecare" element={<PrivateRoute><TarefasHomecare /></PrivateRoute>} />
        <Route path="/tarefas-qualidade" element={<PrivateRoute><TarefasQualidade /></PrivateRoute>} />
        <Route path="/indicador-agenda" element={<PrivateRoute><IndicadorAgenda /></PrivateRoute>} />
        <Route path="/agenda-direcao" element={<PrivateRoute><AgendaDirecao /></PrivateRoute>} />
        <Route path="/gestao-pacientes" element={<PrivateRoute><PatientManagement /></PrivateRoute>} />
        <Route path="/upload-indicadores" element={<Navigate to="/uploads?tab=indicadores" replace />} />
        <Route path="/dashboard-indicadores" element={<PrivateRoute><DashboardIndicadores /></PrivateRoute>} />
        <Route path="/upload-geolocalizacao" element={<Navigate to="/uploads?tab=geo" replace />} />
        <Route path="/mapa-pacientes" element={<PrivateRoute><MapaPacientes /></PrivateRoute>} />
        <Route path="/documentos-qualidade" element={<PrivateRoute><DocumentManager /></PrivateRoute>} />
        {/* --- Ocorrências Quality (Fase 7) --- */}
        <Route path="/ocorrencias-setores" element={<PrivateRoute><OcorrenciaSetores /></PrivateRoute>} />
        <Route path="/ocorrencias/:id" element={<PrivateRoute><OcorrenciaDetalhe /></PrivateRoute>} />
        <Route path="/dashboard-hospitalizacao" element={<PrivateRoute><DashboardHospitalizacao /></PrivateRoute>} />
        {/* --- Gestão de Ocorrências V2 (Fase 8) --- */}
        <Route path="/gestao-ocorrencias" element={<PrivateRoute><GestaoOcorrencias /></PrivateRoute>} />
        <Route path="/nova-ocorrencia" element={<PrivateRoute><WizardOcorrencia /></PrivateRoute>} />
        <Route path="/admin-tutoriais" element={<PrivateRoute><AdminTutoriais /></PrivateRoute>} />
        <Route path="/aulas" element={<PrivateRoute><TutoriaisPublico /></PrivateRoute>} />
        <Route path="/html-viewer" element={<PrivateRoute><HtmlViewer /></PrivateRoute>} />
        <Route path="/upload-planilha" element={<Navigate to="/uploads?tab=telefonia" replace />} />
        <Route path="/dashboard-planilha" element={<PrivateRoute><DashboardPlanilha /></PrivateRoute>} />
        <Route path="/telefonia-ao-vivo" element={<PrivateRoute><PainelTelefonia /></PrivateRoute>} />
        <Route path="/zaping" element={<PrivateRoute><TesteJarvis /></PrivateRoute>} />
        <Route path="/teste-jarvis" element={<Navigate to="/zaping" replace />} />
        <Route path="/upload-openzap" element={<Navigate to="/uploads?tab=openzap" replace />} />
        <Route path="/dashboard-openzap" element={<PrivateRoute><DashboardOpenzap /></PrivateRoute>} />
        <Route path="/escalas" element={<PrivateRoute><EscalasTecnicos /></PrivateRoute>} />
        <Route path="/escalas-enfermeiros" element={<PrivateRoute><EscalasEnfermeiros /></PrivateRoute>} />
        <Route path="/formulario-passagem" element={<PrivateRoute><FormularioPassagem /></PrivateRoute>} />
        <Route path="/gestao-passagens" element={<PrivateRoute><GestaoPassagens /></PrivateRoute>} />
        
        {/* Fluxo de Profissionais */}
        <Route path="/portal-cooperativa" element={<PrivateRoute><PortalCooperativa /></PrivateRoute>} />
        <Route path="/portal-rh" element={<PrivateRoute><PortalRH /></PrivateRoute>} />
        <Route path="/portal-ti" element={<PrivateRoute><PortalTI /></PrivateRoute>} />
        <Route path="/agenda-captacao" element={<PrivateRoute><AgendaCaptacao /></PrivateRoute>} />
        <Route path="/painel-captacao" element={<Navigate to="/gestao-captacao?fullscreen=1" replace />} />
        <Route path="/gestao-captacao" element={<PrivateRoute><Captacao key="gestao" /></PrivateRoute>} />
        <Route path="/painel-implantados"    element={<PrivateRoute><PainelImplantados /></PrivateRoute>} />
        <Route path="/dashboard-implantacao" element={<PrivateRoute><DashboardImplantacao /></PrivateRoute>} />
        <Route path="/dashboard-feridas" element={<PrivateRoute><DashboardFeridas /></PrivateRoute>} />
        <Route path="/dashboard-hub" element={<PrivateRoute><DashboardHub /></PrivateRoute>} />
        <Route path="/dashboard-dispositivos" element={<PrivateRoute><DashboardDispositivos /></PrivateRoute>} />
        <Route path="/uploads" element={<PrivateRoute><UploadHub /></PrivateRoute>} />
        <Route path="/dashboard-visitas" element={<PrivateRoute><DashboardVisitas /></PrivateRoute>} />
        <Route path="/intranet" element={<PrivateRoute><Intranet /></PrivateRoute>} />
        <Route path="/dashboard-prontuario" element={<PrivateRoute><DashboardProntuario /></PrivateRoute>} />

        {/* ── Dashboards em elaboração ── */}
        <Route path="/gestao-orcamentos"            element={<PrivateRoute><GestaoOrcamentos /></PrivateRoute>} />
        <Route path="/gestao-contas-enviadas"       element={<PrivateRoute><PainelProrrogacoes key="envio" tipo="envio" /></PrivateRoute>} />
        <Route path="/pendencia-orcamentos"         element={<PrivateRoute><PainelProrrogacoes key="orcamento" tipo="orcamento" /></PrivateRoute>} />
        <Route path="/gestao-visitas-produtividade" element={<PrivateRoute><GestaoVisitasProdutividade /></PrivateRoute>} />

        {/* ── Homecare ── */}
        <Route path="/gestao-previa-recargas"        element={<PrivateRoute><GestaoPreviaRecargas /></PrivateRoute>} />
        <Route path="/gestao-solicitacao-remocao"    element={<PrivateRoute><GestaoSolicitacaoRemocao /></PrivateRoute>} />
        <Route path="/gestao-solicitacao-troca"      element={<PrivateRoute><GestaoSolicitacaoTroca /></PrivateRoute>} />
        <Route path="/gestao-solicitacao-exames"     element={<PrivateRoute><GestaoSolicitacaoExames /></PrivateRoute>} />
        <Route path="/gestao-monitoramento-clinico"  element={<PrivateRoute><GestaoMonitoramentoClinico /></PrivateRoute>} />
        <Route path="/envio-carefy"                  element={<PrivateRoute><EnvioCarefy /></PrivateRoute>} />
        <Route path="/gestao-feridas"                element={<PrivateRoute><GestaoFeridas /></PrivateRoute>} />
        <Route path="/gestao-ouvidorias"             element={<PrivateRoute><GestaoOuvidorias /></PrivateRoute>} />
        <Route path="/ouvidoria-monitoramento"        element={<PrivateRoute><OuvidoriaMonitoramento /></PrivateRoute>} />
        <Route path="/gestao-remocoes"               element={<PrivateRoute><GestaoRemocoes /></PrivateRoute>} />
        <Route path="/regras-contrato"               element={<PrivateRoute><RegrasContrato /></PrivateRoute>} />
        <Route path="/abrir-chamado"                 element={<PrivateRoute><AbrirChamado /></PrivateRoute>} />
        <Route path="/meus-chamados"                 element={<PrivateRoute><MeusChamados /></PrivateRoute>} />
        <Route path="/chamado/:id"                   element={<PrivateRoute><ChamadoDetalhes /></PrivateRoute>} />
        <Route path="/painel-chamados"               element={<PrivateRoute><PainelChamados /></PrivateRoute>} />
        <Route path="/liberacao-kits"                element={<PrivateRoute><LiberacaoKits /></PrivateRoute>} />
        <Route path="/controle-dispositivos"         element={<PrivateRoute><GestaoSolicitacaoTroca /></PrivateRoute>} />
        <Route path="/painel-infeccao"               element={<PrivateRoute><PainelInfeccao /></PrivateRoute>} />
        <Route path="/huddle-homecare"                element={<PrivateRoute><Huddle /></PrivateRoute>} />
        <Route path="/gestao-controladoria"          element={<PrivateRoute><GestaoControladoria /></PrivateRoute>} />
        <Route path="/gestao-logistica"              element={<PrivateRoute><GestaoLogistica /></PrivateRoute>} />
        <Route path="/inep"                          element={<PrivateRoute><InepEnsino /></PrivateRoute>} />

        <Route path="/convites" element={<PrivateRoute><Convites /></PrivateRoute>} />
        <Route path="/minha-agenda" element={<PrivateRoute><MinhaAgenda /></PrivateRoute>} />
        <Route path="/email" element={<PrivateRoute><Email /></PrivateRoute>} />
        <Route path="/minhas-tarefas" element={<PrivateRoute><MinhasTarefas /></PrivateRoute>} />
        <Route path="/notificacoes" element={<Navigate to="/convites" replace />} />

        {/* Redirecionamento padrão */}
        <Route path="*" element={<Navigate to={user ? "/home" : "/login"} />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;